import classNames from "classnames";
import { memo } from "react";
import * as dividerCss from "./divider.module.css";
import { styleClasses, StyleProps } from "./styles";

export const Divider = memo(function Divider({
  classes,
}: {
  classes?: string;
}) {
  return (
    <hr
      className={classNames(dividerCss.divider, classes)}
      data-web="Divider"
    />
  );
});

interface DividerWithTextProps extends StyleProps {
  text: string;
}

export const DividerText = memo(function DividerText(
  props: DividerWithTextProps,
) {
  return (
    <div
      className={classNames(styleClasses({ ...props }), dividerCss.dividerText)}
      data-web="DividerText"
    >
      {props.text}
    </div>
  );
});
